<form>
  <mat-form-field class="full-width search-input">
    <mat-label>Search</mat-label>
    <mat-chip-grid #chipGrid aria-label="Search with filter">
      @for (filter of filters(); track $index) {
        @if (filter.filter) {
          <mat-chip-row
            class="filter-name"
          >
            <span>{{ filter.filter }}</span>
          </mat-chip-row>
        }
        @if (filter.operator) {
          <mat-chip-row
            class="filter-operator"
            (removed)="removeLastOperator()"
          >
            <span>{{ filter.operator }}</span>
          </mat-chip-row>
        }
        @if (filter.value) {
          <mat-chip-row
            class="filter-value"
            (removed)="removeLastValue()"
          >
            <span>{{ filter.value }}</span>
          </mat-chip-row>
        }
        @if (!$last) {
          <mat-chip>AND</mat-chip>
        } @else if (lastFilter()) {
          <mat-chip>AND</mat-chip>
        }
      }
      @if (lastFilter()) {
        @if (lastFilter()!.filter) {
          <mat-chip-row
            class="filter-name"
            (removed)="removeLastFilter()">
            <span>{{ lastFilter()!.filter }}</span>
          </mat-chip-row>
        }
        @if (lastFilter()!.operator) {
          <mat-chip-row
            class="filter-operator"
            (removed)="removeLastOperator()">
            <span>{{ lastFilter()!.operator }}</span>
          </mat-chip-row>
        }
        @if (lastFilter()!.value) {
          <mat-chip-row
            class="filter-value"
          >
            <span>{{ lastFilter()!.value }}</span>
          </mat-chip-row>
        }
      }
      <input
        name="currentFruit"
        placeholder="Paper title"
        #searchInput
        [(ngModel)]="currentInput"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event); searchInput.value = ''">
        @for (filter of filteredFilterBlocks(); track $index) {
          <mat-option [value]="filter">{{ filter }}</mat-option>
        }
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>

</form>
